var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_40015363_4941)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7172 5.83369C12.9836 7.14112 12.7937 8.50036 12.1793 9.68474C11.5648 10.8691 10.5629 11.8071 9.34057 12.3421C8.11826 12.8772 6.74947 12.9771 5.46244 12.6251C4.17542 12.2731 3.04796 11.4905 2.2681 10.4079C1.48823 9.3252 1.10309 8.00792 1.17691 6.67567C1.25072 5.34342 1.77903 4.07675 2.67373 3.08688C3.56843 2.09701 4.77544 1.44378 6.09347 1.23612C7.41151 1.02847 8.76089 1.27895 9.9166 1.94578",
    stroke: "#05DF72",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.25 6.41634L7 8.16634L12.8333 2.33301",
    stroke: "#05DF72",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_40015363_4941"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/checkIcon.69cde7a908c977cda168f6f158b02372.svg";
export { ForwardRef as ReactComponent };